import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import InlineLoading from "../../../../../components/Loading/Loading";
import MonthlyProfitAndLoss from "../../../../../models/financials/MonthlyProfitAndLoss";
import { primary } from "../../../../../assets/colorPallet";

function YearlyProfitAndLossConsolidation({
  currentCompanyMonthlyProfitAndLoss,
}) {
  if (!(currentCompanyMonthlyProfitAndLoss instanceof MonthlyProfitAndLoss)) {
    return <InlineLoading />;
  }

  return (
    <>
      <div className="flex items-center w-full mt-10">
        <div
          style={{ backgroundColor: primary }}
          className="absolute left-0 w-full h-12 bg-gradient-to-r from-transparent z-10 pointer-events-none"
        ></div>
        <div className="z-20" style={{ minWidth: "20em" }}></div>
        {currentCompanyMonthlyProfitAndLoss?.yearsFormatted.map((year) => (
          <div className="z-20 w-40 font-semibold" style={{ minWidth: "10em" }}>
            <label className="text-white">{year}</label>
          </div>
        ))}
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label className="font-semibold">Total Sales</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.yearlyTotalSales?.map((item) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className="font-semibold">
                {CurrencyFormatter.format(item?.value, { code: "USD" })}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label>(Total Cost of Goods)</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.yearlyTotalCostOfSales?.map(
            (item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label>
                  ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">Gross Profit</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalGrossProfits?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Gross Profit Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyGrossProfitMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>(Total Operating Expenses)</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalOperatingExpenses?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Operating Expenses Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyOperExpenseMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">Operating Income</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalOperatingIncome?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Operating Income Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyOperIncomeMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>Total Other Income</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalOtherIncomes?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Other Income Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyOtherIncomeMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label>(Total Other Expenses)</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalOtherExpenses?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Other Expenses Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyOtherExpensesMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">
              Earnings Before Income Taxes
            </label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.yearlyEarningsBeforeIncomeTaxes?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">EBIT Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyEBITMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>Interest Income</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalInterestIncome?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">(Interest Income Margin)</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyInterestIncomeMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label>(Interest Expense)</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalInterestExpense?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Interest Expense Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyInterestExpenseMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">Pre-Tax Net Profit</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalPreTaxNetProfits?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">EBT Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyEBTMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-4"
            style={{ minWidth: "20em" }}
          >
            <label>(Income Tax)</label>
          </div>
          <div className="flex pt-4">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalIncomeTax?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label>
                    ({CurrencyFormatter.format(item?.value, { code: "USD" })})
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Income Tax Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyIncomeTaxMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-2"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">After-Tax Net Profit</label>
          </div>
          <div className="flex pt-2 border-t">
            {currentCompanyMonthlyProfitAndLoss?.yearlyTotalAfterTaxNetProfits?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">Net Profit Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.yearlyNetProfitMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyMonthlyProfitAndLoss:
    state.financials.currentCompanyMonthlyProfitAndLoss,
});

export default connect(mapStateToProps)(YearlyProfitAndLossConsolidation);
